import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-jumbotron",
    templateUrl: "./jumbotron.component.html",
    styleUrls: ["./jumbotron.component.css"],
    standalone: false
})
export class JumbotronComponent {
  constructor() {}

  id = "tsparticles";

  /* Starting from 1.19.0 you can use a remote url (AJAX request) to a JSON with the configuration */
  /* or the classic JavaScript object */
  particlesOptions = {
    background: {
      color: {
        value: "transparent",
      },
    },
    fpsLimit: 60,
    interactivity: {
      modes: {
        bubble: {
          distance: 400,
          duration: 2,
          opacity: 0.8,
          size: 40,
        },
        push: {
          quantity: 4,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: "#9ad0ff",
      },
      links: {
        color: "#74a8d6",
        distance: 150,
        enable: true,
        opacity: 0.4,
        width: 1,
      },
      collisions: {
        enable: true,
      },
      move: {
        direction: "none",
        enable: true,
        outMode: "bounce",
        random: true,
        speed: 0.6,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          value_area: 650,
        },
        value: 45,
      },
      opacity: {
        value: 0.45,
      },
      shape: {
        type: "circle",
      },
      size: {
        random: true,
        value: 6,
      },
    },
    detectRetina: true,
    connectParticles: true,
  };
}
